import {
  Component,
  AfterViewInit,
  OnInit,
  Inject,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from "@angular/material/dialog";
import { GestionVendedorService } from "src/app/servicios/gestion-vendedor.service";
import { DataTableDirective } from "angular-datatables";
import { Observable, Subject } from "rxjs";
import { PickingService } from "src/app/servicios/picking.service";
import { UsuarioService } from "src/app/servicios/usuario.service";
import { map, startWith } from "rxjs/operators";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { PickingAsignacionService } from "src/app/servicios/picking-asignacion.service";
import Swal from "sweetalert2/dist/sweetalert2.all.js"; // CAMBIA EN PROXIMAS VERSIONES EN ESTA DEBE IMPORTARSE ASI
import { ConsultarPickingComponent } from "src/app/components/picking/consultar-picking/consultar-picking.component";

export interface Combox {
  id: string;
  valor: string;
}

@Component({
  selector: "app-dialog-asignacion-picking",
  templateUrl: "./dialog-asignacion-picking.component.html",
  styleUrls: ["./dialog-asignacion-picking.component.css"],
})
export class DialogAsignacionPickingComponent implements OnInit {
  @ViewChild("mapContainer") gmap: ElementRef;
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  map: google.maps.Map;
  coordinates: any;
  marker: any;
  dataModified = false;
  dtTrigger = new Subject();
  haveData = false;
  timeRunning = 0;
  loadingData = false;
  totalPedido = 0;
  listaDetallePicking = [];
  dataPicking: any;
  loadingTransportador = false;
  listaTransportadores: Observable<Combox[]>;
  data: Combox[];
  asignacionGroup: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<DialogAsignacionPickingComponent>,
    @Inject(MAT_DIALOG_DATA) public dataDialog: any,
    private formBuilder: FormBuilder,
    private servicioPickingAsignacion: PickingAsignacionService,
    private servicioPicking: PickingService,
    private serviceUsuario: UsuarioService,
    private snackBar: MatSnackBar
  ) {
    this.dataPicking = dataDialog[0];
    this.cargarDetallePicking(this.dataPicking.idPickingCargue);
    this.cargarGroup();
    this.cargarTransportador();
  }

  cargarGroup() {
    this.asignacionGroup = this.formBuilder.group({
      cbxTransportador: ["", Validators.required],
    });
  }

  cargarTransportador() {
    this.loadingTransportador = true;

    this.serviceUsuario.getUsuariosTransportador(2, 0).subscribe((result) => {
      this.data = result;
      this.loadingTransportador = false;
      this.listaTransportadores = this.asignacionGroup
        .get("cbxTransportador")
        .valueChanges.pipe(
          startWith(""),
          map((data) => (data ? this._filterCombox(data) : this.data.slice()))
        );
    });
  }

  private _filterCombox(value: any): Combox[] {
    let filterValue: any;
    if (typeof value === "object") {
      filterValue = value.valor.toLowerCase();
    } else {
      filterValue = value.toLowerCase();
    }
    //const filterValue = value.valor.toLowerCase();

    return this.data.filter(
      (data) => data.valor.toLowerCase().indexOf(filterValue) > -1
    );
  }

  async cargarDetallePicking(idPickingCargue) {
    let data = await this.servicioPicking
      .getConsultarPickingModuloDetalle(idPickingCargue)
      .toPromise();
    this.listaDetallePicking = data;
    this.loadingData = true;
    this.servicioPicking
      .getConsultarPickingModuloDetalle(idPickingCargue)
      .subscribe((data) => {
        this.listaDetallePicking = data;
        this.loadingData = false;
        if (data.length > 0) {
          this.haveData = true;
        }
        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;
      });
  }

  displayFn(combox) {
    return combox ? combox.valor : combox;
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit() {
    //this.mapInitializer();
  }

  mapInitializer() {
    this.coordinates = new google.maps.LatLng(
      this.dataPicking.Latitud,
      this.dataPicking.Longitud
    );
    this.marker = new google.maps.Marker({
      position: this.coordinates,
      map: this.map,
    });
    this.map = new google.maps.Map(this.gmap.nativeElement);
    this.map.setZoom(16);
    this.map.setCenter(
      new google.maps.LatLng(
        this.dataPicking.Latitud,
        this.dataPicking.Longitud
      )
    );
    this.marker.setMap(this.map);
  }

  public registrarAsignacion() {
    /*USUARIO*/
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));

    /*DATA DEL REGISTRO*/
    let dataForm = this.asignacionGroup.value;
    dataForm.idEncabezado = 0;
    dataForm.idPickingCargue = this.dataPicking.idPickingCargue;
    dataForm.idUsuario = infoUsuario[0].IdUsuario;
    dataForm.estado = 1;
    this.servicioPickingAsignacion
      .postRegistrarAsignacion(dataForm)
      .subscribe((data) => {
        if (data.respuesta == 0) {
          Swal.fire({
            title: "Asignación de Entregador",
            text: "Realizada con exito.",
            icon: "success",
          });
          this.dataModified = true;
        }
      });
  }

  onNoClick(): void {
    /*Alternativa para cerrar el dialogo*/
    this.dialogRef.close(this.dataModified);
  }
}
